import CollapsibleDetailView from "@components/molecules/CollapsibleDetailView";
import PriceDetailView from "@components/molecules/PriceDetailView";
import { useTypographyStore } from "@redux/slices/typographySlice";
import React, { useMemo, useState } from "react";
import { useTheme } from "styled-components/native";
import styled from "styled-components/native";
import { ProductCommentViewProps } from "../types";
import { PriceModes } from "@components/molecules/PriceModeCard/types";

const ProductCommentView = ({
  ref,
  itemDetail,
  productColor,
  priceMode,
  productType,
}: ProductCommentViewProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const [expandView, setExpandView] = useState(false);

  const DetailComponent = useMemo(() => {
    return (
      <PriceDetailContainer>
        <PriceDetailView
          itemDetail={itemDetail}
          priceMode={priceMode}
          productType={productType}
          productColor={productColor}
          expandView={expandView}
        />
      </PriceDetailContainer>
    );
  }, [
    itemDetail,
    priceMode,
    typography,
    expandView,
    itemDetail?.total_sales_price,
  ]);

  return (
    <Container ref={ref}>
      {itemDetail?.pricing_comment && priceMode === PriceModes.WHITE ? (
        <CollapsibleDetailView
          expandView={expandView}
          setExpandView={setExpandView}
          initExpanded={expandView}
          title={DetailComponent}
          arrowStyling={{ color: theme["core-06"] }}
          forceExpand={true}
        />
      ) : (
        <>{DetailComponent}</>
      )}
    </Container>
  );
};

const Container = styled.View``;

const PriceDetailContainer = styled.View`
  flex-direction: column;
`;

export default ProductCommentView;
